module.exports = require('./generated/thrift_all.js').crouton_thrift;
